import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import IHaveAQuestionButton
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/IHaveAQuestionButtonPicker/IHaveAQuestionButton/IHaveAQuestionButton';

const IHaveAQuestionButtonPicker = ({ resource, completed, handleQuestionOnClick }) => {
  return pick(resource, {
    [fr.relationships.question.name]: <IHaveAQuestionButton completed={completed} handleQuestionOnClick={handleQuestionOnClick} />,
  }, null);
};

export default IHaveAQuestionButtonPicker;
